import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  loaded: false
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setConfig: (state, action) => {
      state.data = action.payload;
      state.loaded = true;
    }
  }
});

export const { setConfig } = configSlice.actions;
export default configSlice.reducer;